export default __webpack_public_path__ + "static/media/google-register-1-en.6cf6dddd.jpeg";